import React, { useEffect, useState } from 'react'
import { Form, Select, DatePicker, Space, Slider } from 'antd'
import moment, { Moment } from 'moment'
import locale from 'antd/es/date-picker/locale/es_ES'
import {
	EDestinationTypeCapital,
	EDestinationTypeCorriente,
	EExpenseDestinationNature,
	EExpenseType,
} from '../../typings'
import {
	capitalize,
	enumToArray,
	formatDate,
	snakeCaseToTitle,
} from '../../util'
import { useDebounce, useExpensesQuery } from '../../hooks'

const { Option } = Select

const SearchWidget = () => {
	const [expensesQuery, dispatch] = useExpensesQuery()
	const [amountRange, setAmountRange] = useState<[number, number]>([0, 20000])
	const { debouncedValue: debouncedAmountRange } = useDebounce(amountRange, 500)
	const handleChange = (key: string) => (value: any) => {
		if (dispatch) {
			const payload = {
				...expensesQuery,
				match: {
					...expensesQuery.match,
					[key]: value,
				},
			}

			dispatch({
				type: 'SET',
				payload,
			})
		}
	}

	const handleDateRangeChange = (times: any) => {
		if (dispatch) {
			const payload = {
				...expensesQuery,
				match: {
					...expensesQuery.match,
					from: times ? formatDate((times[0] as Moment).toDate()) : undefined,
					to: times ? formatDate((times[1] as Moment).toDate()) : undefined,
				},
			}

			dispatch({
				type: 'SET',
				payload,
			})
		}
	}

	const handleAmountRangeChange = (range: [number, number]) => {
		setAmountRange(range)
	}

	useEffect(() => {
		const [from, to] = debouncedAmountRange
		if (dispatch) {
			const payload = {
				amount: {
					gte: from,
					lte: to,
				},
			}

			dispatch({
				type: 'SET_MATCH',
				payload,
			})
		}
	}, [debouncedAmountRange, dispatch])

	return (
		<Form style={{ marginTop: '1.5rem' }} onValuesChange={handleChange}>
			<Form.Item>
				<Select
					value={expensesQuery.match.type}
					defaultValue={expensesQuery.match.type}
					placeholder='Tipo de gasto'
					onChange={handleChange('type')}
					allowClear
				>
					{enumToArray(EExpenseType).map((item, i) => (
						<Option
							key={i}
							value={item}
							style={{ textTransform: 'capitalize' }}
						>
							{capitalize(item)}
						</Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item>
				<Select
					value={expensesQuery.match.destinationType}
					placeholder='Justificación'
					onChange={handleChange('destinationType')}
					allowClear
				>
					{[
						...enumToArray(
							expensesQuery.match.type === EExpenseType.Corriente ||
								!expensesQuery.match.type
								? EDestinationTypeCorriente
								: []
						),
						...enumToArray(
							expensesQuery.match.type === EExpenseType.Capital ||
								!expensesQuery.match.type
								? EDestinationTypeCapital
								: []
						),
					].map((item, i) => (
						<Option key={i} value={item}>
							{snakeCaseToTitle(item)}
						</Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item>
				<Select
					value={expensesQuery.match.destinationNature}
					placeholder='Naturaleza del destino'
					onChange={handleChange('destinationNature')}
					allowClear
				>
					{enumToArray(EExpenseDestinationNature).map((item, i) => (
						<Option key={i} value={item}>
							{snakeCaseToTitle(item)}
						</Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item>
				<Space direction='vertical' size={12}>
					<DatePicker.RangePicker
						onChange={handleDateRangeChange}
						ranges={{
							Hoy: [moment(), moment()],
							'Este Mes': [moment().startOf('month'), moment().endOf('month')],
							'Este Año': [moment().startOf('year'), moment().endOf('year')],
						}}
						locale={{
							...locale,
							lang: {
								...locale.lang,
								rangePlaceholder: ['Desde', 'Hasta'],
							},
						}}
					/>
				</Space>
			</Form.Item>
			<Form.Item>
				<p>Rango de Monto Transaccional</p>
				<Slider
					range
					min={0}
					max={20000}
					defaultValue={[0, 20000]}
					step={1000}
					tipFormatter={(s) => `$${s}`}
					onChange={handleAmountRangeChange}
				/>
			</Form.Item>
		</Form>
	)
}

export default SearchWidget
